import { render, staticRenderFns } from "./novalEdit.vue?vue&type=template&id=bc16cf0e&scoped=true"
import script from "./novalEdit.vue?vue&type=script&lang=js"
export * from "./novalEdit.vue?vue&type=script&lang=js"
import style0 from "./novalEdit.vue?vue&type=style&index=0&id=bc16cf0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc16cf0e",
  null
  
)

export default component.exports